/* VR Variant Selector — color fijo + talla dependiente del color + talla preferida persistente.
   Reemplaza el IIFE viejo. NO edita product-info.js: lo envuelve.
   CLAVE: el tema Ella marca la seleccion con la CLASE .checked en el input (no la propiedad nativa).
   Datos: <script data-vr-variant-availability> emitido en variant-main-picker.liquid. */
(function () {
  'use strict';
  try { console.log('VR-VERIF: K7M3 | asset vr-variant-selector.js | tema DEV 162891628788'); } catch (e) {}

  // Congelar updateOptionValues: es lo unico que repinta <variant-selects> (evita el re-render
  // bidireccional que mueve/tacha colores). Ella sigue gestionando la clase .checked en su handler.
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-info').then(function () {
      var PI = customElements.get('product-info');
      if (!PI || PI.prototype.__vrPatched) return;
      PI.prototype.__vrPatched = true;
      PI.prototype.updateOptionValues = function () { /* VR: selector fijo */ };
    });
  }

  var DESIRED = {}; // talla preferida persistente por <variant-selects>

  function rowsOf(vs) { var el = vs.querySelector('[data-vr-variant-availability]'); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function colorFs(vs) { return vs.querySelector('fieldset.variant-option--swatches'); }
  function sizeFs(vs) { return vs.querySelector('fieldset.variant-option--pill'); }
  function keyOf(vs) { return vs.id || vs.getAttribute('data-section') || 'vr'; }
  function radios(fs) { return fs ? [].slice.call(fs.querySelectorAll('input[type="radio"]')) : []; }

  // Ella marca la seleccion con la CLASE .checked (no la propiedad nativa del radio)
  function selVal(fs) { var r = fs && fs.querySelector('input.checked'); return r ? r.value : null; }
  function findRadio(fs, val) { var rs = radios(fs); for (var i = 0; i < rs.length; i++) if (rs[i].value === val) return rs[i]; return null; }
  function clickRadio(fs, val) { var r = findRadio(fs, val); if (r) { r.click(); return true; } return false; } // Ella procesa: clase + precio/imagen/form
  // input[name=id] del form asociado a este variant-selects (para sincronizar la variante sin fetch)
  function formInput(vs) {
    var node = vs;  // subir el arbol hasta el input[name=id] mas cercano (getElementById falla por el quirk form.id)
    for (var d = 0; node && node !== document.body && d < 10; d++) {
      var inp = node.querySelector ? node.querySelector('input[name="id"], select[name="id"]') : null;
      if (inp) return inp;
      node = node.parentElement;
    }
    return null;
  }
  function varId(rows, color, size) {
    for (var i = 0; i < rows.length; i++) { if (rows[i].size === size && (color == null || rows[i].color === color)) return rows[i].id; }
    return null;
  }

  function availByColor(rows) { var m = {}; rows.forEach(function (r) { if (!m[r.color]) m[r.color] = {}; if (r.available) m[r.color][r.size] = true; }); return m; }
  function colorHasStock(rows) { var m = {}; rows.forEach(function (r) { if (r.available) m[r.color] = true; }); return m; }

  function labelFor(fs, inp) { var l = inp.id ? fs.querySelector('label[for="' + inp.id + '"]') : null; if (!l && inp.nextElementSibling && inp.nextElementSibling.tagName === 'LABEL') l = inp.nextElementSibling; return l; }
  function setHidden(el, hide) { if (!el) return; if (hide) el.setAttribute('data-vr-hidden', ''); else el.removeAttribute('data-vr-hidden'); }
  function setLabel(fs, val) { if (!fs) return; var s = fs.querySelector('[data-selected-value]'); if (s && val != null) s.textContent = val; }

  // talla mas comun: numeros -> central del rango disponible; letras -> M>L>primera
  function commonSize(sizes) {
    if (!sizes.length) return null;
    var allNum = sizes.every(function (s) { return /^\d+(\.\d+)?$/.test(String(s).trim()); });
    if (allNum) { var s = sizes.map(Number).sort(function (a, b) { return a - b; }); return String(s[Math.floor((s.length - 1) / 2)]); }
    if (sizes.indexOf('M') !== -1) return 'M';
    if (sizes.indexOf('L') !== -1) return 'L';
    return sizes[0];
  }
  // tallas disponibles del color en ORDEN del DOM
  function tallasDeColor(vs, color) {
    var rows = rowsOf(vs), sf = sizeFs(vs); if (!rows || !sf) return [];
    var by = availByColor(rows), avail = by[color] || {}, out = [];
    radios(sf).forEach(function (inp) { if (avail[inp.value]) out.push(inp.value); });
    return out;
  }

  // visibilidad de tallas segun color (no toca colores)
  function applySizes(vs, color) {
    var rows = rowsOf(vs), sf = sizeFs(vs); if (!rows || !sf) return;
    var avail;
    if (colorFs(vs)) { var by = availByColor(rows); avail = (color != null && by[color]) ? by[color] : {}; }
    else { avail = {}; rows.forEach(function (r) { if (r.available) avail[r.size] = true; }); } // solo-talla: disponibilidad global
    var any = false;
    radios(sf).forEach(function (inp) {
      var hide = !avail[inp.value];
      setHidden(inp, hide); setHidden(labelFor(sf, inp), hide);
      if (!hide) any = true;
    });
    var msg = sf.querySelector('[data-vr-no-sizes]');
    if (msg) { if (any) msg.setAttribute('hidden', ''); else msg.removeAttribute('hidden'); }
  }
  // ocultar colores 100% agotados (global, no depende de la talla)
  function applyColors(vs) {
    var rows = rowsOf(vs), cf = colorFs(vs); if (!rows || !cf) return;
    var stock = colorHasStock(rows);
    radios(cf).forEach(function (inp) {
      var li = inp.closest('li'), hide = !stock[inp.value];
      setHidden(li || inp, hide);
      if (!li) setHidden(labelFor(cf, inp), hide);
    });
  }
  // quitar seleccion de talla (clase + nativo + label) -> ninguna talla marcada
  function clearSize(vs) {
    var sf = sizeFs(vs); if (!sf) return;
    radios(sf).forEach(function (i) { i.classList.remove('checked'); i.checked = false; });
    setLabel(sf, '');
  }
  // Ella resuelve la variante para el carrito leyendo la propiedad nativa :checked.
  // La mantenemos sincronizada con la clase .checked (que es lo que Ella pinta) para que
  // al cambiar de color/talla resuelva la variante correcta y no caiga a la primera (agotada).
  function syncNative(vs) {
    [colorFs(vs), sizeFs(vs)].forEach(function (fs) {
      if (!fs) return;
      radios(fs).forEach(function (i) {
        var on = i.classList.contains('checked');
        i.checked = on;
        if (on) i.setAttribute('checked', ''); else i.removeAttribute('checked'); // el tema usa el atributo [checked] para el estilo visual
      });
    });
  }
  // marcar la clase .checked de una talla sin disparar a Ella (visual inmediato, sin flash)
  function setSizeClass(vs, value) {
    var sf = sizeFs(vs); if (!sf) return;
    radios(sf).forEach(function (i) { if (i.value === value) i.classList.add('checked'); else i.classList.remove('checked'); });
    setLabel(sf, value);
  }

  function init(vs) {
    if (vs.__vrInit) return; vs.__vrInit = true;
    var rows = rowsOf(vs); if (!rows) return;
    applyColors(vs);
    var cf = colorFs(vs);
    if (cf) {
      var stock = colorHasStock(rows), color = selVal(cf);
      if (!color || !stock[color]) {           // color inicial invalido (oculto/sin stock) -> primer visible con stock
        var rs = radios(cf);
        for (var i = 0; i < rs.length; i++) { if (stock[rs[i].value]) { color = rs[i].value; break; } }
        if (color) clickRadio(cf, color);      // click => Ella marca el color
      }
      applySizes(vs, color);
      setLabel(cf, color);
      var common = commonSize(tallasDeColor(vs, color));
      DESIRED[keyOf(vs)] = common;
      if (common) {
        setSizeClass(vs, common); syncNative(vs);            // visual inmediato (sin flash)
        var fi = formInput(vs), id = varId(rows, color, common);
        if (fi && id) fi.value = id;                          // sincroniza el form sin fetch (mismo color: precio/imagen ya correctos)
      }
    } else {                                    // solo talla
      applySizes(vs, null);
      var availAny = {}; rows.forEach(function (r) { if (r.available) availAny[r.size] = true; });
      var sizes = []; radios(sizeFs(vs)).forEach(function (i) { if (availAny[i.value]) sizes.push(i.value); });
      var c = commonSize(sizes); DESIRED[keyOf(vs)] = c;
      if (c) {
        setSizeClass(vs, c); syncNative(vs);
        var fi2 = formInput(vs), id2 = varId(rows, null, c);
        if (fi2 && id2) fi2.value = id2;
      }
    }
    syncNative(vs);
  }

  // usuario cambia color -> el color es e.target.value
  function onColorChange(vs, color) {
    applySizes(vs, color);
    setLabel(colorFs(vs), color);
    var sizes = tallasDeColor(vs, color), desired = DESIRED[keyOf(vs)];
    if (desired && sizes.indexOf(desired) !== -1) {
      if (selVal(sizeFs(vs)) !== desired) clickRadio(sizeFs(vs), desired);          // preferida existe -> re-seleccionar (si no lo esta ya)
    } else clearSize(vs);                                                           // no existe -> sin talla (preferida se conserva)
    syncNative(vs);
  }

  function wire(vs) {
    if (vs.__vrWired) return; vs.__vrWired = true;
    // CAPTURA (antes que Ella): si se cambia el COLOR, aseguramos que la talla tenga la propiedad
    // nativa = su clase .checked, para que Ella resuelva color/talla-actual y no la 1a (agotada).
    vs.addEventListener('change', function (e) {
      var t = e.target; if (!t || t.type !== 'radio') return;
      var cf = colorFs(vs), sf = sizeFs(vs);
      // sincronizar el native del OTRO eje (= su clase) para que Ella resuelva la variante color+talla correcta
      if (cf && cf.contains(t)) { if (sf) radios(sf).forEach(function (i) { i.checked = i.classList.contains('checked'); }); }
      else if (cf) { radios(cf).forEach(function (i) { i.checked = i.classList.contains('checked'); }); }
    }, true);
    // BUBBLE: nuestra logica
    vs.addEventListener('change', function (e) {
      var t = e.target; if (!t || t.type !== 'radio') return;
      var cf = colorFs(vs);
      if (cf && cf.contains(t)) onColorChange(vs, t.value);
      else { DESIRED[keyOf(vs)] = t.value; setLabel(sizeFs(vs), t.value); syncNative(vs); } // talla => nueva preferida
    });
  }

  function boot(vs) { wire(vs); init(vs); }
  function bootAll(root) { [].forEach.call((root || document).querySelectorAll('variant-selects[data-context^="main"], variant-selects[data-context^="sticky"]'), boot); }

  // arrancar DESPUES de que <product-info> de Ella se inicialice (si no, pisa la preseleccion)
  document.addEventListener('product-info:loaded', function (e) { bootAll(e.target); });
  document.addEventListener('shopify:section:load', function (e) { bootAll(e.target); });
  // Ella resetea la propiedad nativa :checked en su flujo async (tras el fetch).
  // Re-sincronizamos native = clase tras cada variant-change, para que el siguiente
  // cambio de color resuelva la variante correcta (no la primera/agotada).
  function syncAll() { [].forEach.call(document.querySelectorAll('variant-selects[data-context^="main"], variant-selects[data-context^="sticky"]'), function (vs) { try { syncNative(vs); } catch (e) {} }); }
  document.addEventListener('variant:update', syncAll);
  try { if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, syncAll); } catch (e) {}
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-info').then(function () {
      requestAnimationFrame(function () { requestAnimationFrame(function () { bootAll(); }); });
    });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(); });
  } else { bootAll(); }
  // El sticky add-to-cart se inserta tarde; reintentos acotados para cubrirlo (y cualquier picker diferido).
  [500, 1500, 3500].forEach(function (ms) { setTimeout(function () { bootAll(); }, ms); });
  window.addEventListener('load', function () { bootAll(); });
})();
